export default __webpack_public_path__ + "static/about-us-banner-8c2e3072145454f7c78358cb295db80f.png";